import { render, staticRenderFns } from "./ImageRegion.vue?vue&type=template&id=0230eabc&scoped=true&"
import script from "./ImageRegion.vue?vue&type=script&lang=js&"
export * from "./ImageRegion.vue?vue&type=script&lang=js&"
import style0 from "./ImageRegion.vue?vue&type=style&index=0&id=0230eabc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0230eabc",
  null
  
)

export default component.exports